"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResendEmailIcon = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var ResendEmailIcon = function ResendEmailIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", {
    viewBox: "0 0 24 24",
    width: width,
    height: height
  }, _react2.default.createElement("defs", null, _react2.default.createElement("path", {
    d: "M22 14.52a1.07 1.07 0 0 1-.19.28l-3 3a.91.91 0 0 1-.63.26.89.89 0 0 1-.88-.885.88.88 0 0 1 .26-.625L19 15.06h-3.9a1.54 1.54 0 0 0-1.54 1.53v3a.88.88 0 1 1-1.76 0v-3a3.3 3.3 0 0 1 3.3-3.3H19l-1.51-1.51a.88.88 0 0 1 0-1.25.89.89 0 0 1 1.25 0l3 3a.94.94 0 0 1 .26.63 1 1 0 0 1 0 .36zM20.74 3v4.5a.79.79 0 1 1-1.58 0v-3L11 10.2a.81.81 0 0 1-.91 0L2 4.52v9.71a1.08 1.08 0 0 0 1.1 1.08h5.41a.79.79 0 1 1 0 1.58H3.1a2.67 2.67 0 0 1-2.67-2.66V3A2.67 2.67 0 0 1 3.1.34h15A2.67 2.67 0 0 1 20.74 3zm-1.66-.36a1.07 1.07 0 0 0-1-.72H3.1a1.07 1.07 0 0 0-1 .72l8.5 6 8.48-6z",
    id: "a"
  })), _react2.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("g", {
    transform: "translate(.5 1.5)"
  }, _react2.default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, _react2.default.createElement("use", {
    xlinkHref: "#a"
  })), _react2.default.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), _react2.default.createElement("g", {
    mask: "url(#b)",
    fill: color
  }, _react2.default.createElement("path", {
    d: "M-13.5-14.5h50v50h-50z"
  }))), _react2.default.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.01,
    opacity: 0.01,
    d: "M.005.005h23.99v23.99H.005z"
  })));
};

exports.ResendEmailIcon = ResendEmailIcon;